import { configureStore } from "@reduxjs/toolkit";

import authReducer from "./modules/common/store/authReducer";
import uiReducer from "./modules/common/store/uiReducer";
import experienceReducer from "./modules/dashboard/experience/store/experienceReducer";
import bookingReducer from "./modules/dashboard/booking/store/bookingReducer";
import proposalManagerReducer from "./modules/widget/proposal-manager/store/proposalManagerReducer";
import recordsOrderingReducer from "./modules/widget/records-ordering/store/recordsOrderingReducer";

const store = configureStore({
  reducer: {
    auth: authReducer,
    ui: uiReducer,
    experience: experienceReducer,
    booking: bookingReducer,
    proposalManager: proposalManagerReducer,
    recordsOrdering: recordsOrderingReducer,
  },
  devTools: window.devToolsExtension,
});

export default store;
